<!------------------------------

      Page Actions

------------------------------->

<div class="tw-flex tw-justify-end tw-gap-2 tw-mb-3">

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

  <button
    type="button"
    sb-button-primary
    [color]="'blue'"
    [icon]="'list'"
    [loading]="loading()"
    [iconButton]="true"
    [sbRouterLink]="util.RoutingID.tracker"
    [queryParams]="{'locationIds': getLocationId()}"
    sbTooltip="{{ 'lang.globals.showInList' | translate }}"
  >
  </button>

</div>

<!------------------------------

     Table Wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'nav.network.tracker' | translate}}"
  [isInIntegratedContext]="true"
  [itemsData]="trackers"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'tracker'">

  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        {{ 'lang.globals.status' | translate }}
      </th>
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.technique' | translate }}
      </th>
      <th>
        {{ 'lang.globals.identifier' | translate }}
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th class=" sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

 Table Body

------------------------------->
  <ng-template #tbody let-tracker>
    <tr>
      <td>
          <span *ngIf="!tracker?.offline" class="green">
          <sb-icon icon="online"></sb-icon>
            Online
          </span>
        <span *ngIf="tracker?.offline" class="red">
          <sb-icon icon="offline"></sb-icon>
            Offline
          </span>
      </td>
      <td>
        {{ tracker?.id }}
      </td>
      <td>
        <sb-icon icon="{{util.getTrackerIcon(tracker)}}" [ngbTooltip]="tracker.technique" container="body"></sb-icon>
      </td>
      <td>
        <span [innerHTML]="tracker?.identifier | truncate: 30"></span>
      </td>
      <td>
        <sb-comp-link
          [title]="tracker?.name |truncate:30"
          [permission]="permissionService.Permission.visitor_tracker_show"
          [link]="util.RoutingID.trackerDetails"
          [pathParams]="[{id: 'trackerID',value: tracker?.id}]"
          [tooltip]="'lang.globals.details' | translate">
        </sb-comp-link>
      </td>
      <td class="sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="tracker.sbButtons ?? []"
        ></sb-split-button>
      </td>
    </tr>
  </ng-template>
</sb-table-wrapper-new>

